import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MSTTreatmentPlanSignaturePage = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_MSTTreatmentPlanSignaturePage' className='file-pdf-document'>
            <div className='file-template'>
                <p><h3>MST TREATMENT PLAN SIGNATURE PAGE</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I. Person Receiving Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbClinicalInformation" name="cbClinicalInformation" className='add-only' value="1" />  I confirm and agree with my involvement in the development of this PCP. My signature means that I agree with the services/supports to be
                            provided.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbServiceProviders_2" name="cbServiceProviders_2" className='add-only' value="2" />  I understand that I have the choice of service providers and may change service providers at any time, by contacting the person responsible for this PCP.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDevelopmentalDisabilities" name="cbDevelopmentalDisabilities" className='add-only' value="3" />  For CAP-MR/DD services only, I confirm and understand that I have the choice of se eking care in an intermediate care facility for individuals with mental retardation instead of participating in the Community Alternatives Program for individuals with Mental Retardation/Developmental Disabilities (CAP-MR/DD).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legally Responsible Person: Self</span>
                            <input type="radio" id="rbLegallyResponsible_Yes" name="rbLegallyResponsible" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLegallyResponsible_No" name="rbLegallyResponsible" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Person Receiving Services</span>
                            <span className='small'>(Required when person is his/her own legally responsible person)</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature
                        </td>
                        <td className='small w-300'>Print Name
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legally Responsible Person</span>
                            <span className='small'>(Required if other than person receiving services)</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature
                        </td>
                        <td className='small w-300'>Print Name
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Relationship to the individual</span>
                            <input type="text" id="txtRelationshipIndividual1" name="txtRelationshipIndividual1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>II. Person responsible for the PCP </span>
                            <span className='small'>The following signature confirms the responsibility of the QP/LP for the development of this PCP. The signature indicates agreement with the services/supports to be provided.</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature (Person responsible for the PCP, credentials)
                        </td>
                        <td className='small w-300'>(Name of Case Management Agency)
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Child Mental Health Services Only:</span>
                    <span className='small'>
                        <b>For individuals who are less than 21 years of age (less than 18 for State funded services)</b>and who are receiving or in need of enhanced services
                        and who are actively involved with the Department of Juvenile Justice and Delinquency Prevention or the adult criminal court system, the person
                        responsible for the PCP must attest that he or she has completed the following requirements as specified below:
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbFamilyTeam" name="cbFamilyTeam" className='add-only' value="Met with the Child and Family Team" />  Met with the Child and Family Team - </td>
                        <td className='w-375'>
                            <span>Date:</span>
                            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbFamilyTeamMeeting" name="cbFamilyTeamMeeting" className='add-only' value="Child and Family Team meeting scheduled for" />  OR Child and Family Team meeting scheduled for - </td>
                        <td className='w-375'>
                            <span>Date:</span>
                            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCareManager" name="cbCareManager" className='add-only' value="OR Assigned a TASC Care Manager" />  OR Assigned a TASC Care Manager - </td>
                        <td className='w-375'>
                            <span>Date:</span>
                            <input type="date" id="txtDate_3" name="txtDate_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCareCoordination" name="cbCareCoordination" className='add-only' value="AND conferred with the clinical staff of the applicable LME to conduct care coordination." />  AND conferred with the clinical staff of the applicable LME to conduct care coordination.  </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>If the statements above do not apply, please check the box below and then sign as the Person Responsible for the PCP:
                            </b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCriminalCourtSystem" name="cbCriminalCourtSystem" className='add-only' value="This child is not actively involved with the Department of Juvenile Justice and Prevention or the adult criminal court system." />  This child is not actively involved with the Department of Juvenile Justice and Prevention or the adult criminal court system. </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature (Person responsible for the PCP, credentials)
                        </td>
                        <td className='small w-300'>(Print Name)
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <span className='eleHeader'>III. Service Orders  </span>
                <span className='small'>Required for all Medicaid funded services; Recommended for State funded services.</span>
                <span><b>(SECTION A): For services ordered by one of the Medicaid approved licensed signatories (see Instruction Manual).</b></span>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>My signature below confirms the following</span>
                            <span className='small'>(Check all appropriate boxes.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>Medical necessity for services requested is present, and constitutes the Service Order(s).</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>The licensed professional who signs this service order has had direct contact with the individual.</span>
                            <input type="radio" id="rbLicensedProfessionalDirectContact2_Yes" name="rbLicensedProfessionalDirectContact2" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLicensedProfessionalDirectContact2_No" name="rbLicensedProfessionalDirectContact2" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>The licensed professional who signs this service order has reviewed the individual s assessment.</span>
                            <input type="radio" id="rbLicensedProfessionalIndividualAssessment1_Yes" name="rbLicensedProfessionalIndividualAssessment1" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLicensedProfessionalIndividualAssessment1_No" name="rbLicensedProfessionalIndividualAssessment1" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature (Name/Title Required)
                        </td>
                        <td className='small w-300'>(Print Name)
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>License # (If Applicable)
                            <input type="text" id="txtLicenseNo_3" name="txtLicenseNo_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <span><b>(SECTION B): For Qualified Professionals (QP) / Licensed Professionals (LP) ordering:</b></span>
                <ul>
                    <li>CAP-MR/DD or </li>
                    <li>Medicaid Targeted Case Management (TCM) services (if not ordered in Section A) </li>
                    <li>OR recommended for any state-funded services not ordered in Section A.</li>
                </ul>
                <p className='w-750'>
                    <span className='eleHeader'>My signature below confirms the following</span>
                    <span className='small'>(Check all appropriate boxes.) Signatory in this section must be a Qualified or Licensed Professional</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDDServices" name="cbDDServices" className='add-only' value="1" />  Medical necessity for the CAP-MR/DD services requested is present, and constitutes the Service Order.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMedicaidTCMService" name="cbMedicaidTCMService" className='add-only' value="2" />  Medical necessity for the Medicaid TCM service requested is present, and constitutes the Service Order.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbStateFundedService" name="cbStateFundedService" className='add-only' value="3" />  Medical necessity for the State-funded service(s) requested is present and constitutes the Service Order.
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature (Name/Title Required)
                        </td>
                        <td className='small w-300'>(Print Name)
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>License # (If Applicable)
                            <input type="text" id="txtLicenseNo_2" name="txtLicenseNo_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    IV. Signatures of other team members participating in development of the plan
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Team Member (Name/Relationship)</span>
                            <input type="text" id="txtOtherTeamMember_1" name="txtOtherTeamMember_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type="date" id="txtOtherDate_1" name="txtOtherDate_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Team Member (Name/Relationship)</span>
                            <input type="text" id="txtOtherTeamMember_2" name="txtOtherTeamMember_2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type="date" id="txtOtherDate_2" name="txtOtherDate_2" className='add-only' />
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
